<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <svg class="absolute inset-0 w-full h-full opacity-5" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="circuitContact" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
            <path d="M40,0 L40,80 M0,40 L80,40" stroke="rgba(59, 130, 246, 0.3)" stroke-width="0.5" fill="none"/>
            <circle cx="40" cy="40" r="2" fill="rgba(59, 130, 246, 0.4)"/>
            <circle cx="15" cy="15" r="1.5" fill="rgba(99, 102, 241, 0.3)"/>
            <circle cx="65" cy="65" r="1.5" fill="rgba(99, 102, 241, 0.3)"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#circuitContact)"/>
      </svg>

      <!-- <div class="absolute top-1/4 left-1/4 w-24 h-24 border border-blue-200/30 rounded-lg transform rotate-45"></div> -->
      <div class="absolute bottom-1/3 right-1/4 w-16 h-16 border border-blue-300/30 rounded-full"></div>
      <div class="absolute top-1/2 left-1/3 w-32 h-32 border border-blue-100/20 rounded-full"></div>
    </div>

    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20 relative">
      <!-- Header -->
      <div class="text-center mb-4 md:mb-1">
        <div class="inline-flex items-center gap-3 mb-4">
          <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
          </div>
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            Contact <span class="text-blue-600">Us</span>
          </h1>
        </div>
        <p class="text-gray-600 max-w-2xl mx-auto text-lg md:text-xl">
          Get in touch with our security experts for immediate assistance
        </p>
      </div>

      <!-- Two Column Layout: Contact Form & Quick Contact -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-5">
        <!-- Contact Form Column -->
        <div class="cyber-card bg-white rounded-2xl border border-gray-200 shadow-lg p-6 md:p-8">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
            </div>
            <h2 class="text-2xl font-bold text-gray-900">Send Secure Message</h2>
          </div>

          <form @submit.prevent="submitForm" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="form-group">
                <label class="block text-sm font-semibold text-gray-700 mb-2">
                  <span class="flex items-center gap-2">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    Full Name
                  </span>
                </label>
                <input 
                  type="text" 
                  v-model="form.name" 
                  required
                  class="cyber-input w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Enter your full name"
                />
              </div>

              <div class="form-group">
                <label class="block text-sm font-semibold text-gray-700 mb-2">
                  <span class="flex items-center gap-2">
                    <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                    </svg>
                    Phone Number
                  </span>
                </label>
                <input 
                  type="tel" 
                  v-model="form.phone" 
                  required
                  class="cyber-input w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="+237 620 050 515"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <span class="flex items-center gap-2">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                  Email Address
                </span>
              </label>
              <input 
                type="email" 
                v-model="form.email" 
                required
                class="cyber-input w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                placeholder="your.email@example.com"
              />
            </div>

            <div class="form-group">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                <span class="flex items-center gap-2">
                  <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                  </svg>
                  Your Message
                </span>
              </label>
              <textarea 
                v-model="form.message" 
                rows="5"
                required
                class="cyber-input w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none"
                placeholder="Describe your security concern or inquiry..."
              ></textarea>
            </div>

            <button 
              type="submit"
              class="w-full cyber-button bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg flex items-center justify-center gap-2"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
              </svg>
              Send Secure Message
            </button>
          </form>
        </div>

        <!-- Redesigned Quick Contact Column -->
        <div class="cyber-card bg-gradient-to-br from-blue-50 via-white to-blue-50 rounded-2xl border border-blue-100 shadow-lg p-6 md:p-8">
          <div class="flex items-center gap-3 mb-8">
            <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"/>
              </svg>
            </div>
            <h2 class="text-2xl font-bold text-gray-900">Quick Contact</h2>
          </div>

          <!-- Contact Methods Grid -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <!-- WhatsApp Card -->
            <a href="https://wa.me/+237620050515" target="_blank" 
               class="contact-method-card bg-gradient-to-br from-green-50 to-green-100 hover:from-green-100 hover:to-green-200 border border-green-200">
              <div class="contact-icon bg-gradient-to-br from-green-500 to-green-600">
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2zm.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 012.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24zM8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.28-.25-.13-1.46-.72-1.69-.8-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.14.17-.29.19-.53.07-.25-.13-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01z"/>
                </svg>
              </div>
              <div class="flex-1">
                <h3 class="font-bold text-gray-900 mb-1">WhatsApp</h3>
                <p class="text-gray-600 text-sm">+237 620 050 515</p>
                <span class="inline-flex items-center gap-1 text-green-600 text-xs font-semibold mt-2">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                  </svg>
                  Available 24/7
                </span>
              </div>
              <svg class="w-5 h-5 text-green-600 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
              </svg>
            </a>

            <!-- Phone Card -->
            <div class="contact-method-card bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200">
              <div class="contact-icon bg-gradient-to-br from-blue-500 to-blue-600">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
              </div>
              <div class="flex-1">
                <h3 class="font-bold text-gray-900 mb-1">Phone</h3>
                <p class="text-gray-600 text-sm">+237 222 22 40 46</p>
                <span class="inline-flex items-center gap-1 text-blue-600 text-xs font-semibold mt-2">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/>
                  </svg>
                  9AM - 5PM (WAT)
                </span>
              </div>
            </div>

            <!-- Email Card -->
            <div class="contact-method-card bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200">
              <div class="contact-icon bg-gradient-to-br from-purple-500 to-purple-600">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </div>
              <div class="flex-1">
                <h3 class="font-bold text-gray-900 mb-1">Email</h3>
                <p class="text-gray-600 text-sm">incident@cirt.cm</p>
                <span class="inline-flex items-center gap-1 text-purple-600 text-xs font-semibold mt-2">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                  </svg>
                  Secure & Encrypted
                </span>
              </div>
            </div>

            <!-- Office Card -->
            <div class="contact-method-card bg-gradient-to-br from-amber-50 to-amber-100 border border-amber-200">
              <div class="contact-icon bg-gradient-to-br from-amber-500 to-amber-600">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
              </div>
              <div class="flex-1">
                <h3 class="font-bold text-gray-900 mb-1">Office</h3>
                <p class="text-gray-600 text-sm">Chinese Embassy Area</p>
                <span class="inline-flex items-center gap-1 text-amber-600 text-xs font-semibold mt-2">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
                  </svg>
                  Bastos, Yaounde
                </span>
              </div>
            </div>
          </div>

          <!-- Social Media Section -->
          <div class="border-t border-blue-100 pt-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              Follow Us
            </h3>
            <div class="flex gap-3">
              <a v-for="social in socialMedia" :key="social.name" :href="social.url" target="_blank"
                 class="social-media-button group" :class="social.color">
                <component :is="social.icon" class="w-5 h-5" />
                <span class="text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  {{ social.name }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Google Maps Section (Below both columns) -->
      <div class="cyber-card bg-white rounded-2xl border border-gray-200 shadow-lg overflow-hidden">
        <div class="p-6 border-b border-gray-100">
          <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                Visit Our Headquarters
              </h2>
              <p class="text-gray-600 mt-2">Chinese Embassy Area, Bastos, Yaounde, Cameroon</p>
            </div>
            <button @click="openGoogleMaps" 
                    class="direction-button bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg flex items-center justify-center gap-2 whitespace-nowrap">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
              </svg>
              Get Directions
            </button>
          </div>
        </div>
        
        <!-- Map Container -->
        <div class="relative h-80 md:h-96 bg-gray-100 overflow-hidden">
          <!-- Interactive Map Preview -->
          <div class="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-100">
            <!-- Map Grid Background -->
            <div class="absolute inset-0" style="background-size: 40px 40px; background-image: 
              linear-gradient(to right, rgba(59, 130, 246, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(59, 130, 246, 0.1) 1px, transparent 1px);">
            </div>
            
            <!-- Location Marker -->
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <!-- Pulse Animation -->
              <div class="absolute inset-0">
                <div class="absolute inset-0 rounded-full bg-blue-500 opacity-20 animate-ping"></div>
                <div class="absolute inset-0 rounded-full bg-blue-500 opacity-20 animate-ping" style="animation-delay: 1s"></div>
              </div>
              
              <!-- Main Marker -->
              <div class="relative">
                <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform">
                  <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  </svg>
                </div>
                <div class="w-3 h-8 bg-gradient-to-b from-blue-600 to-blue-700 mx-auto -mt-2 rounded-b-full"></div>
              </div>
            </div>

            <!-- Location Label -->
            <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3 shadow-lg">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                  <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                  </svg>
                </div>
                <div>
                  <div class="font-bold text-gray-900">ANTIC Headquarters</div>
                  <div class="text-gray-600 text-sm">Chinese Embassy Area, Bastos</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Map Info Footer -->
        <div class="bg-gradient-to-r from-blue-50 to-gray-50 p-4 border-t border-gray-200">
          <div class="flex items-center justify-between text-sm text-gray-600">
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>Opening Hours: Mon-Fri 8:00 AM - 5:00 PM</span>
            </div>
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              <span>Parking Available • Wheelchair Accessible</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer class="mt-20" />
  </div>
</template>

<script>
import Footer from '@/components/common/Footer.vue';

// Social Media Icons as Components
const FacebookIcon = {
  template: `
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  `
};

const TwitterIcon = {
  template: `
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
    </svg>
  `
};

const LinkedInIcon = {
  template: `
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  `
};

export default {
  name: 'ContactUs',
  components: {
    Footer,
    FacebookIcon,
    TwitterIcon,
    LinkedInIcon
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        message: '',
      },
      socialMedia: [
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/ANTIC237',
          icon: 'FacebookIcon',
          color: 'hover:bg-blue-600 hover:text-white bg-blue-100 text-blue-600'
        },
        {
          name: 'Twitter',
          url: 'https://twitter.com',
          icon: 'TwitterIcon',
          color: 'hover:bg-sky-600 hover:text-white bg-sky-100 text-sky-600'
        },
        {
          name: 'LinkedIn',
          url: 'https://linkedin.com/company/antic/',
          icon: 'LinkedInIcon',
          color: 'hover:bg-blue-700 hover:text-white bg-blue-100 text-blue-700'
        }
      ]
    };
  },
  methods: {
    submitForm() {
      alert('Thank you for contacting us! Your message has been securely sent. We will get back to you within 1 hour.');
      this.form = { name: '', phone: '', email: '', message: '' };
    },
    openGoogleMaps() {
      const address = encodeURIComponent('Chinese Embassy Bastos Yaounde Cameroon');
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
    },
  },
};
</script>

<style scoped>
/* Cyber Card Styles */
.cyber-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.cyber-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.05), transparent);
  transition: left 0.7s ease;
}

.cyber-card:hover::before {
  left: 100%;
}

.cyber-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

/* Contact Method Card */
.contact-method-card {
  @apply p-4 rounded-xl flex items-center gap-4 transition-all duration-300 cursor-pointer;
  position: relative;
  overflow: hidden;
}

.contact-method-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.contact-method-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.7s ease;
}

.contact-method-card:hover::after {
  left: 100%;
}

.contact-icon {
  @apply w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-md;
  transition: transform 0.3s ease;
}

.contact-method-card:hover .contact-icon {
  transform: scale(1.1) rotate(5deg);
}

/* Social Media Buttons */
.social-media-button {
  @apply w-12 h-12 rounded-xl flex flex-col items-center justify-center gap-1 transition-all duration-300;
  flex: 1;
}

.social-media-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Direction Button */
.direction-button {
  position: relative;
  overflow: hidden;
}

.direction-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.direction-button:hover::before {
  width: 300px;
  height: 300px;
}

/* Cyber Input Styles */
.cyber-input {
  background: white;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.cyber-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: white;
}

/* Cyber Button Styles */
.cyber-button {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.cyber-button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

.cyber-button:focus:not(:active)::after {
  animation: ripple 1s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    transform: scale(20, 20);
    opacity: 0;
  }
}

/* Form Group Animation */
.form-group {
  position: relative;
}

.form-group label {
  transition: all 0.3s ease;
}

/* Map Animation */
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

.animate-ping {
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .contact-method-card {
    padding: 0.75rem;
  }
  
  .contact-icon {
    width: 2.5rem;
    height: 2.5rem;
  }
  
  .social-media-button {
    width: 2.75rem;
    height: 2.75rem;
  }
  
  .direction-button {
    width: 100%;
    margin-top: 1rem;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .cyber-card,
  .contact-method-card,
  .social-media-button,
  .direction-button,
  .contact-icon,
  .form-group label {
    transition: none;
  }
  
  .cyber-card:hover,
  .contact-method-card:hover,
  .social-media-button:hover {
    transform: none;
  }
  
  .cyber-card::before,
  .contact-method-card::after {
    display: none;
  }
  
  .animate-ping {
    animation: none;
  }
}
</style>